import React from 'react';
import ReactDOM from 'react-dom';

import Iconset from './icons';

import '../styles/loader.scss';


class Loaderelement extends React.Component{

	constructor(props){
		super(props);
	}

	render(){
		return (
			<div className={this.props.isLoading + "-loading loader"}>
				<div className="loader-inner">
					<Iconset.loader />	
				</div>
			</div>
			);
	}
}


export default Loaderelement;


// WEBPACK FOOTER //
// ./src/scripts/loaderelement.js